module.exports = __webpack_public_path__ + "img/arrowleft.695d4cde.svg";